document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.getElementById('my-menu');
  const mega = document.getElementById('my-mega-menu');
  const header = document.querySelector('.header-section');
  let t, armed = false;

  if (!trigger || !mega || !header) return;

  const isOpen = () => mega.classList.contains('is-open');
  const open = () => { clearTimeout(t); mega.classList.add('is-open'); };
  const scheduleClose = () => {
    clearTimeout(t);
    t = setTimeout(() => { mega.classList.remove('is-open'); armed = false; }, 300);
  };

  const onEnterTrigger = () => { armed = true; open(); };
  const onEnterKeepOpen = () => { if (armed || isOpen()) open(); };

  ['mouseenter', 'focusin'].forEach(e => {
    trigger.addEventListener(e, onEnterTrigger);
    mega.addEventListener(e, onEnterKeepOpen);
    header.addEventListener(e, onEnterKeepOpen);
  });

  ['mouseleave', 'focusout'].forEach(e => {
    trigger.addEventListener(e, scheduleClose);
    mega.addEventListener(e, scheduleClose);
    header.addEventListener(e, scheduleClose);
  });
});
